import React from "react";
import { default as MuiTabContext } from "@mui/lab/TabContext";

function TabContext(props) {
  return <MuiTabContext {...props} />;
}

export default TabContext;
